import React from 'react';

export type LomavisCampaignText1Variant =
  | 'eyebrow'
  | 'sectionNumber'
  | 'helper'
  | 'sectionTitle';

export interface LomavisCampaignText1Props {
  variant: LomavisCampaignText1Variant;
  children: React.ReactNode;
  className?: string;
}

export const LomavisCampaignText1: React.FC<LomavisCampaignText1Props> = ({
  variant,
  children,
  className = ''
}) => {
  const variantClass =
    variant === 'sectionTitle'
      ? 'd-block m-0 text-body fs-5 fw-bold lh-sm'
      : variant === 'helper'
      ? 'd-block m-0 text-muted small fw-medium lh-base'
      : 'd-block m-0 text-muted text-uppercase small fw-bold lh-sm';

  return <span className={`${variantClass} ${className}`}>{children}</span>;
};
